import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiClient }  from "../config/api";
import { ColorArray } from "../config/ColorArray";
import "./Cards.css";
import Loader from "../common/Loader";

const Cards = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // ⭐ Clean function to fix Unicode + multiple spaces
  const clean = (str) =>
    String(str)
      .replace(/\s+/g, " ") // multiple spaces → one space
      .replace(/\u00A0/g, " ") // remove NBSP
      .trim()
      .toLowerCase();

  useEffect(() => {
    const fetchDepartments = async () => {
      try {
        const res = await apiClient.get("/department");

        console.log("API FULL RESPONSE =", res.data);

        const findArray = (obj) => {
          if (!obj) return null;
          if (Array.isArray(obj)) return obj;

          if (typeof obj === "object") {
            for (let key in obj) {
              const result = findArray(obj[key]);
              if (result) return result;
            }
          }
          return null;
        };

        const departmentData = findArray(res.data) || [];

        const sortedData = departmentData.sort((a, b) => {
          const indexA = parseInt(a.index) || 0;
          const indexB = parseInt(b.index) || 0;
          return indexA - indexB;
        });

        setData(sortedData);
        setError(null);
      } catch (err) {
        setError(err.message || "Failed to fetch departments");
        setData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchDepartments();
  }, []);

  const getCardColor = (index) => {
    return ColorArray[index % ColorArray.length];
  };

  // ⭐ UPDATED ROUTING — NOW PERFECTLY WORKS
const handleCardClick = (item) => {
  // ⭐ MUKHYA VIBHAG ID SAVE HERE
  localStorage.setItem(
    "mukhyaVibhag",
    JSON.stringify({
      id: item.id || item._id,
      title: item.title,
    })
  );

  const title = clean(item.title);

  if (title.includes("બાળ")) navigate("/bal-vibhag");

  // higher first
  else if (title.includes("ઉચ્ચતર પ્રાથમિક"))
    navigate("/upper-primary");

  else if (title.includes("ઉચ્ચતર માધ્યમિક"))
    navigate("/higher-secondary");

  // normal
  else if (title.includes("પ્રાથમિક"))
    navigate("/prathmik-vibhag");

  else if (title.includes("માધ્યમિક"))
    navigate("/madhyamik-vibhag");

  else console.log("⚠ Route Not Found For:", item.title);
};



  if (loading)
    return (
      <div className="cards-container">
        <Loader />
      </div>
    );

  if (error) {
    return (
      <div className="cards-container">
        <div className="cards-error">
          <h2>⚠️ Error</h2>
          <p>{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="cards-container">
      {data.length === 0 ? (
        <div className="cards-empty">
          <div className="cards-empty-icon">📭</div>
          <p>No departments found.</p>
        </div>
      ) : (
        <div className="cards-grid">
          {data.map((item, index) => {
            const colors = getCardColor(index);

            return (
              <div
                key={item.id || item._id}
                className="card"
                style={{
                  background: `linear-gradient(135deg, ${colors.color1}, ${colors.color2})`,
                }}
                onClick={() => handleCardClick(item)}
              >
                <div className="card-content">
                  {item.image ? (
                    <div className="card-image-wrapper">
                      <img src={item.image} alt={item.title} className="card-image" />
                    </div>
                  ) : (
                    <div className="card-image-wrapper">
                      <div className="card-image-placeholder">🏢</div>
                    </div>
                  )}

                  <h3 className="card-title">{item.title}</h3>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default Cards;
